import React from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { paymentStatusSnackbarState, giftCheckoutState } from "../../../Recoil/Atoms";
import { useSecondModal } from "../../../helpers/hooks/useSecondModal";
import "./style.css";

// Bit payment FAILURE, approved design (_previews/payment-snackbar): the same
// card as UploadErrorSnackbar. role=alert, stays until closed or "לנסות שוב"
// (reopens the payment-method choice the customer came from). A successful
// payment has no snackbar: the modal closes and the success page's own
// SuccessReveal tells it (owner, 2026-10-02: the snackbar duplicated it).
const PaymentStatusSnackbar = () => {
  const [snack, setSnack] = useRecoilState(paymentStatusSnackbarState);
  const giftCheckout = useRecoilValue(giftCheckoutState);
  const secondModal = useSecondModal();

  if (!snack) return null;

  const close = () => setSnack(null);

  const retry = () => {
    const via = snack.retry || (window.innerWidth < 768 ? "selectCardMobile" : "selectCard");
    setSnack(null);
    // A failed Bit leg drops the GC- id from localStorage, but the gift intent is
    // still pending and the payment popup charges the id it finds there.
    if (giftCheckout && giftCheckout.giftOrderId && !localStorage.getItem("orderId")) {
      localStorage.setItem("orderId", giftCheckout.giftOrderId);
    }
    secondModal("open", via);
  };

  return (
    <div className="pay-snack-wrap">
      <div key={snack.id} className="pay-snack pay-snack--bad" role="alert">
        <div className="pay-snack-ic">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <path d="M5 5l6 6M11 5l-6 6" stroke="#c43d3d" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </div>
        <div className="pay-snack-txt">
          <span className="pay-snack-ttl">התשלום לא הושלם</span>
          <span className="pay-snack-msg">לא בוצע חיוב</span>
        </div>
        <button type="button" className="pay-snack-act" onClick={retry}>לנסות שוב</button>
        <button type="button" className="pay-snack-x" aria-label="סגור" onClick={close}>&times;</button>
      </div>
    </div>
  );
};

export default PaymentStatusSnackbar;
